export enum WidgetDeeplinks {
  WIDGET_SMALL = 'WIDGET_SMALL',
  WIDGET_MEDIUM = 'WIDGET_MEDIUM',
  MENS_CALENDAR_SMALL_WIDGET = 'MENS_CALENDAR_SMALL_WIDGET',
  MENS_CALENDAR_MEDIUM_WIDGET = 'MENS_CALENDAR_MEDIUM_WIDGET',
}
